import { DeterministicView } from '@bingads-webui/deterministic-view';
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { InputControl } from '@bingads-webui/input-control';
import _ from 'underscore';
import $ from 'jquery';
import template from './bid-cap-view-template.pug';

export const getBidCapView = ({ i18n, config, fixedBidSchema }) => {
  if (!i18n || !config || !fixedBidSchema) {
    return {};
  }
  /**
   * Shared view for Hotel Ads max bid setup section
   * @extends Backbone.View
   */
  class BidCapView extends DeterministicView {
    initialize() {
      this.selections = {
        empty: 'empty',
        cap: 'cap',
      };

      this.i18n = i18n;

      const FixedBidModel = backboneSchema(fixedBidSchema, i18n, ['Amount', '@odata.type']);

      this.fixedBidModel = new FixedBidModel();
      const maxBidInputControl = new InputControl({
        entity: this.fixedBidModel,
        field: 'Amount',
        addonText: config.get('AccountCurrencyCode'),
      });

      this.setChild('max-bid-input', maxBidInputControl);
      this.listenTo(maxBidInputControl, 'input-changed', () => {
        this.trigger('input-changed');
      });

      this.setState({ capSelection: this.selections.empty });

      this.on('rendered', () => {
        const capSelection = this.model.get('capSelection');
        if (capSelection === 'empty') {
          $('label.empty').focus();
        } else if (capSelection === 'cap') {
          $('label.bid-selection-label').focus();
        }
      }, this);
    }

    get events() {
      return {
        'change .bid-cap-radio': ({ target }) => {
          this.setState({ capSelection: target.value });
        },
      };
    }

    setState(state) {
      if (_.has(state, 'capSelection')) {
        this.model.set('capSelection', state.capSelection);
      }

      if (_.has(state, 'maximumBid')) {
        this.fixedBidModel.parse(state.maximumBid);
        this.getChild('max-bid-input').setState({ value: this.fixedBidModel.get('Amount') });
      }

      this.trigger('input-changed');
      return this;
    }

    getState() {
      const inputState = this.getChild('max-bid-input').getState();
      const noCap = this.model.get('capSelection') === this.selections.empty;

      return {
        maximumBid: noCap ? null : this.fixedBidModel.toJSON(),
        isValid: noCap || inputState.isValid,
      };
    }

    get template() {
      return template;
    }
  }

  return {
    BidCapView,
  };
};
